(function () {
  'use strict';

  angular
      .module('tfc.Reports', [])
      .constant('ReportCategories', [
        'week', 'month', 'quarter', 'other'
      ])
      .config(config);

  // @ngInject
  function config($stateProvider, ReportCategories) {

    $stateProvider
        .state('reportList', {
          parent : 'pageWithMenu',
          url : '/reports?tla',
          abstract : true,
          template : '<div ui-view class="fade-in"/>'
        })
        .state('reportList.all', {
          url : '/all',
          data : {
            auth : {
              privilege : 'retailerViewReports',
              defaultTo : 'help'
            },
            requireTerms:true,
            title:'All Reports',
            path:'reports/all'
          },
          controller : 'AllReportsCtrl as vm',
          templateUrl : 'Reports/AllReports.tmpl.html',
          resolve : {
            reports : function (Reports, $stateParams) {
              var tla = Reports.defaultTla($stateParams.tla);
              return tla ? Reports.find(tla) : [];
            }
          }
        })
    ;

    ReportCategories.forEach(function (category) {
      $stateProvider
          .state('reportList.' + category, {
            data : {
              reportCategory : category,
              auth : {
                privilege : 'retailerViewReports',
                defaultTo: 'help'
              },
              requireTerms:true,
              title: 'Category Report - ' + category,
              path:'reports/' + category
            },
            url : '/' + category,
            controller : 'CategoryReportsCtrl as vm',
            templateUrl : 'Reports/CategoryReports.tmpl.html',
            resolve : {
              defaultTla : function(Reports, $stateParams){
                return Reports.defaultTla($stateParams.tla);
              },
              reports : function (Reports, defaultTla) {
                return defaultTla ? Reports.find(defaultTla, category) : [];
              },
              reportsCount: function(Reports, defaultTla){
                return Reports.reportCount(defaultTla, category);
              }
            }
          })
    });
  }

})();